var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto",class:{ 'bg-putty': _vm.backgroundGray }},[_c('div',{staticClass:"matrix-block max-w-expanded-md mx-auto"},[_c('VideoWithHeading',{attrs:{"video":_vm.asset,"autoplay":_vm.autoplay,"controls":!_vm.autoplay,"muted":!_vm.autoplay,"full-width":"","ratio":_vm.aspectRatio,"data-test-id":"asset"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }